/**
 * Standard data table — the single table style used across the Platform Admin
 * dashboard. columns: [{ key, label, align: 'left'|'right', className, render(row) }]
 */
const DataTable = ({ columns, rows = [], rowKey = 'id', minWidth = 640, emptyMessage = 'No data', testId }) => (
  <div className="overflow-x-auto -mx-4 sm:mx-0">
    <table className="w-full text-sm" style={{ minWidth }} data-testid={testId}>
      <thead className="bg-gray-50">
        <tr>
          {columns.map((col) => (
            <th
              key={col.key}
              className={`px-4 py-3 font-medium text-gray-600 ${col.align === 'right' ? 'text-right' : 'text-left'}`}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="px-4 py-8 text-center text-gray-400">
              {emptyMessage}
            </td>
          </tr>
        ) : (
          rows.map((row, i) => (
            <tr key={row[rowKey] ?? i} className="hover:bg-gray-50 transition-colors">
              {columns.map((col) => (
                <td
                  key={col.key}
                  className={`px-4 py-3 ${col.align === 'right' ? 'text-right' : 'text-left'} ${col.className || ''}`}
                >
                  {col.render ? col.render(row) : row[col.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default DataTable;
